import { VariantProps } from "@gluestack-ui/utils";
import React from "react";
import { textStyle } from "./Text.styles";

type ITextProps = React.ComponentProps<"span"> & VariantProps<typeof textStyle>;

const Text = React.forwardRef<React.ComponentRef<"span">, ITextProps>(
	(
		{
			className,
			isTruncated,
			medium,
			semiBold,
			bold,
			extraBold,
			underline,
			strikeThrough,
			size = "md",
			sub,
			italic,
			highlight,
			variant = "primary",
			...props
		}: { className?: string } & ITextProps,
		ref,
	) => {
		return (
			<span
				className={textStyle({
					isTruncated,
					medium,
					semiBold,
					bold,
					extraBold,
					underline,
					strikeThrough,
					size,
					sub,
					italic,
					highlight,
					variant,
					class: className,
				})}
				{...props}
				ref={ref}
			/>
		);
	},
);

Text.displayName = "Text";

export { Text };
